export default __webpack_public_path__ + "static/buycoins-796f6dd6440a64e57cf85db89ae2f845.jpg";